var Handlebars = require("/Users/wcweb/Documents/fdt_workspace/adHelper/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "          <li class='error-panel' >\n            <a href='javascript:void(0)'>\n\n              "
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.o : depth0)) != null ? stack1.lang : stack1)) != null ? stack1.noResultText : stack1), depth0))
    + "\n            \n            </a>\n          </li>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "                 <li class=\"\">\n\n       \n                  <a href=\"javascript:void(0)\" class=\"cue\" id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\" title=\""
    + alias2(alias1((depth0 != null ? depth0.title : depth0), depth0))
    + "\">\n                  <span class=\"cue-content\">"
    + alias2(alias1((depth0 != null ? depth0.title : depth0), depth0))
    + "</span>\n                  <span class=\"cue-seektime\">["
    + alias2(__default(require("/Users/wcweb/Documents/fdt_workspace/adHelper/src/webpack/helpers/digits.js")).call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.seekTime : depth0),{"name":"digits","hash":{},"data":data}))
    + "]</span>\n                  </a>\n\n             </li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return " <div class=\"cuepoints-panel\">\n <a class=\"close-btn\" href=\"javascript:void(0)\">X</a>\n <div class=\"cuepoints-infos\" >\n  <div class=\"cuepoints-title\">\n        <h1>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.o : depth0)) != null ? stack1.title : stack1), depth0))
    + "</h1>\n  </div>\n  <div class=\"cuepoints-description\">\n   "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.o : depth0)) != null ? stack1.introduction : stack1), depth0))
    + " \n</div>\n</div>\n<div class=\" cuepoints-toolbar\"> \n      <div id=\"repeat_btn\" >\n            <input type=\"checkbox\"  name=\"repaet_or\" value=\"loop\" />\n            <a href=\"javascript:void(0)\"> "
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.o : depth0)) != null ? stack1.lang : stack1)) != null ? stack1.clickForReloopText : stack1), depth0))
    + "</a>\n      </div>\n</div>\n<div class=\" cuepoints-wrapper \">\n      <ul class=\"cues cue-pills\">\n     \n"
    + ((stack1 = helpers.unless.call(alias3,(depth0 != null ? depth0.isEmpty : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers.each.call(alias3,(depth0 != null ? depth0.cuePointsArr : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "      </ul>\n</div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/webpack/templates/cuehelper_template.handlebars
// module id = 28
// module chunks = 2 3